import React, { ReactNode, Dispatch, SetStateAction } from "react";
import { XIcon } from "@primer/octicons-react";

interface ModalHeaderProps {
  children: ReactNode;
  className?: string;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
  children,
  className = "",
  setOpen,
}) => {
  return (
    <div
      className={`bg-neutral-100 text-neutral-700 font-semibold text-xl p-2 border-b border-neutral-300 flex ${className}`}
    >
      {children}
      <button type="button" className="ml-auto" onClick={() => setOpen(false)}>
        <XIcon size={24} />
      </button>
    </div>
  );
};

export default ModalHeader;
